import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgArticle(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 3H6v10H3v6a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V3Zm-1 14.5V19a1 1 0 0 1-1 1H6.732A1.99 1.99 0 0 0 7 19V4h12v13.5ZM5 20a1 1 0 0 0 1-1v-5H4v5a1 1 0 0 0 1 1ZM16.807 6.605a.5.5 0 0 1 .088.702l-1.556 2a.5.5 0 0 1-.86-.126l-.101-.258-1.79 1.918a.5.5 0 0 1-.81-.11l-.458-.885-1.462 1.503a.5.5 0 0 1-.716-.697l1.944-2a.5.5 0 0 1 .802.118l.452.871 1.85-1.982a.5.5 0 0 1 .832.16l.069.178 1.014-1.304a.5.5 0 0 1 .702-.088ZM9 13.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm0 2a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);

var ArticleOutline = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { ArticleOutline as default };
